import React from "react";

// Left rail of draggable+clickable "Available Columns" chips sourced from
// the template's available_columns catalog (assisted_conversions columns).
// Native HTML5 draggable + onClick fallback — no DnD library in package.json.
export function AvailableColumnsRail({ columns = [], onAddColumn, mappedSourceColumns = new Set() }) {
  return (
    <div>
      <div style={{ fontSize: 11, color: "#7b7b7b", textTransform: "uppercase", letterSpacing: 1, marginBottom: 10 }}>
        Available Columns
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {columns.length === 0 && (
          <div style={{ fontSize: 12, color: "#B8B8B8" }}>No columns available for this template.</div>
        )}
        {columns.map((col) => {
          const name = typeof col === "string" ? col : col.source_column;
          const label = typeof col === "string" ? col : (col.label || col.source_column);
          const alreadyMapped = mappedSourceColumns.has(name);
          return (
            <div
              key={name}
              draggable
              onDragStart={(e) => e.dataTransfer.setData("text/x-export-column", name)}
              onClick={() => onAddColumn(name)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onAddColumn(name); } }}
              aria-label={`Add column ${label}`}
              style={{
                padding: "8px 12px",
                borderRadius: 8,
                border: `1px solid ${alreadyMapped ? "#F90091" : "#E2E2E2"}`,
                background: alreadyMapped ? "#FFF5FB" : "#FAFAFA",
                color: alreadyMapped ? "#F90091" : "#151515",
                fontSize: 13,
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              {label}
            </div>
          );
        })}
      </div>
    </div>
  );
}
